<app-input-text [name]="name" [label]="label" [placeholder]="placeholder" [hint]="hint" [integer]="integer" [form]="form" [icon]="icon" [class]="class" [type]="'number'" [min]="min" [max]="max" [step]="step" hasCustomPrefix [labelError]="labelError">
  <div prefix>
    <app-button icon="remove" (click)="onDecrementClick()" unfocusable></app-button>
  </div>
  <div suffix>
    <app-button icon="add" (click)="onIncrementClick()" unfocusable></app-button>
  </div>
</app-input-text>
